import { IBaseResponseData, ITreaty } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of treaties from the `/treaty` endpoint.
 */
export interface ITreatyResponse extends IBaseResponseData {
  treaties: ITreaty[]
}
